import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getBrowserHostSurface, getDefaultRouteForSurface } from "../lib/hostSurface";

const GENERIC_PATHS = new Set([
  "/",
  "/reserve",
  "/drops/signals",
  "/digest",
  "/pitch",
  "/aether/brie",
]);

/**
 * When the hostname implies a trust subdomain (verify, ledger, …), nudge generic hub paths
 * to the surface default. Skips deeper manual routes. Uses replace — no history spam.
 */
export function HostSurfaceAutoRoute(): null {
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    const info = getBrowserHostSurface();
    if (info.surface === "home") return;
    if (!GENERIC_PATHS.has(location.pathname)) return;
    const target = getDefaultRouteForSurface(info.surface);
    const cur = `${location.pathname}${location.search}`;
    if (cur === target) return;
    navigate(target, { replace: true });
  }, [location.pathname, location.search, navigate]);

  return null;
}
